/**
 * <s-show-more data-step="12">
 *   Reveals hidden items in batches. Items to reveal carry [data-more-item] and start with the
 *   `hidden` attribute/class; the button carries [data-more-button] and hides itself once every
 *   item is visible.
 */
class SShowMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-more-button]');
    if (!this.button) return;
    this.step = parseInt(this.dataset.step, 10) || 12;
    this.onClick = this.onClick.bind(this);
    this.button.addEventListener('click', this.onClick);
    this.update();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  hiddenItems() {
    return [...this.querySelectorAll('[data-more-item].hidden')];
  }

  onClick() {
    const items = this.hiddenItems().slice(0, this.step);
    items.forEach((item) => item.classList.remove('hidden'));
    items[0]?.querySelector('a, button, [tabindex]')?.focus({ preventScroll: true });
    this.update();
  }

  update() {
    this.button.hidden = this.hiddenItems().length === 0;
  }
}

if (!customElements.get('s-show-more')) customElements.define('s-show-more', SShowMore);
